import React from 'react'
import { Form, Button, Input } from 'antd'
import { Store } from 'antd/es/form/interface'

const ResetPwd: React.FC<IResetPwdProps> = (props) => {

  const form = Form.useForm()[0]

  const reset = (values: Store) => {
    const data = {
      jobNumber: props.jobNumber,
      password: values.password,
      verificationCode: values.verificationCode,
    }
    props.reset(data)
  }

  const compareToFirstPassword = (rule: any, value: any, callback: any) => {
    if (value && value !== form.getFieldValue('password')) {
      callback('两次密码不一致')
    } else {
      callback()
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    }
  }

  return (
    <div>
      <Form {...formItemLayout} form={form} onFinish={reset}>
        <Form.Item label="输入密码" name="password" rules={[{ required: true, message: '请输入密码' }]}>
          <Input.Password type="password" />
        </Form.Item>
        <Form.Item label="再次输入密码" rules={[{ required: true, message: '再次确认密码', }, { validator: compareToFirstPassword }]}>
          <Input.Password type="password" />
        </Form.Item>
        <Form.Item label="输入验证码" name="verificationCode" rules={[{ required: true, message: '请输入验证码', }]}>
          <Input />
        </Form.Item>
        <div className="btn">
          <Button type="primary" className="btn-style" htmlType="submit">重置密码</Button>
        </div>
      </Form>
    </div>
  )
}

interface IResetPwdProps {
  jobNumber: any
  reset: any
}

export default ResetPwd
